import { LoadableBackground } from '@confluence/loadable';

export const PremiumTrialDigestDataModal = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumTrialDigestDataModal" */ './PremiumTrialDigestDataModal.tsx'
			)
		).PremiumTrialDigestDataModal,
});
